// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Feedback form overlay. Reuses the .doc-overlay / .screen.doc shell from
   docOverlay.css for the full-screen sheet; these are the form-specific
   bits. */

.fb__lede {
  font-family: var(--font-display);
  font-size: 1.3rem;
  font-weight: 600;
  line-height: 1.25;
  margin: 6px 0 18px;
}

.fb__choices {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
}
.fb__choice {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 14px 8px;
  border-radius: 14px;
  border: 1.5px solid var(--palette-border);
  background: var(--palette-surface);
  color: var(--palette-text-muted);
  font: inherit;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
}
.fb__choice.selected {
  border-color: var(--palette-primary);
  color: var(--palette-text);
  background: var(--palette-accent-soft);
}
.fb__choice-emoji {
  font-size: 1.5rem;
  line-height: 1;
}

.fb__textarea {
  width: 100%;
  box-sizing: border-box;
  min-height: 140px;
  resize: vertical;
  border-radius: 14px;
  border: 1.5px solid var(--palette-border-strong);
  background: var(--palette-surface);
  color: var(--palette-text);
  padding: 14px;
  font-family: var(--font-ui);
  font-size: 1rem;
  line-height: 1.5;
}
.fb__textarea:focus {
  outline: none;
  border-color: var(--palette-primary);
}

.fb__msg {
  margin-top: 12px;
  font-size: 0.9rem;
  line-height: 1.4;
}
.fb__msg--error {
  color: var(--palette-primary);
}

.fb__cta {
  margin-top: 16px;
}

.fb__diagnostics {
  margin-top: 16px;
  padding: 14px;
  border: 1px solid var(--palette-border);
  border-radius: 14px;
  font-size: 0.9rem;
  line-height: 1.5;
}
.fb__diagnostics-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
}
.fb__diagnostics-toggle input[type="checkbox"] {
  width: auto;
  flex: 0 0 auto;
  margin: 0;
  accent-color: var(--palette-primary);
}
.fb__diagnostics p {
  margin: 10px 0;
}
.fb__diagnostics summary {
  cursor: pointer;
}
.fb__diagnostics pre {
  max-height: 240px;
  overflow: auto;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  font-size: 0.8rem;
}

.fb__sent {
  padding-top: 8px;
}
.fb__sent-title {
  font-family: var(--font-display);
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 10px;
}
.fb__sent-body {
  color: var(--palette-text-muted);
  line-height: 1.55;
  margin: 0 0 18px;
}
`, "",{"version":3,"sources":["webpack://./src/screens/components/feedbackForm.css"],"names":[],"mappings":"AAAA;;UAEU;;AAEV;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,kCAAkC;EAClC,gCAAgC;EAChC,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,sCAAsC;AACxC;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gDAAgD;EAChD,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uCAAuC;EACvC,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,cAAc;EACd,SAAS;EACT,oCAAoC;AACtC;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":["/* Feedback form overlay. Reuses the .doc-overlay / .screen.doc shell from\n   docOverlay.css for the full-screen sheet; these are the form-specific\n   bits. */\n\n.fb__lede {\n  font-family: var(--font-display);\n  font-size: 1.3rem;\n  font-weight: 600;\n  line-height: 1.25;\n  margin: 6px 0 18px;\n}\n\n.fb__choices {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n.fb__choice {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  padding: 14px 8px;\n  border-radius: 14px;\n  border: 1.5px solid var(--palette-border);\n  background: var(--palette-surface);\n  color: var(--palette-text-muted);\n  font: inherit;\n  font-weight: 600;\n  font-size: 0.9rem;\n  cursor: pointer;\n}\n.fb__choice.selected {\n  border-color: var(--palette-primary);\n  color: var(--palette-text);\n  background: var(--palette-accent-soft);\n}\n.fb__choice-emoji {\n  font-size: 1.5rem;\n  line-height: 1;\n}\n\n.fb__textarea {\n  width: 100%;\n  box-sizing: border-box;\n  min-height: 140px;\n  resize: vertical;\n  border-radius: 14px;\n  border: 1.5px solid var(--palette-border-strong);\n  background: var(--palette-surface);\n  color: var(--palette-text);\n  padding: 14px;\n  font-family: var(--font-ui);\n  font-size: 1rem;\n  line-height: 1.5;\n}\n.fb__textarea:focus {\n  outline: none;\n  border-color: var(--palette-primary);\n}\n\n.fb__msg {\n  margin-top: 12px;\n  font-size: 0.9rem;\n  line-height: 1.4;\n}\n.fb__msg--error {\n  color: var(--palette-primary);\n}\n\n.fb__cta {\n  margin-top: 16px;\n}\n\n.fb__diagnostics {\n  margin-top: 16px;\n  padding: 14px;\n  border: 1px solid var(--palette-border);\n  border-radius: 14px;\n  font-size: 0.9rem;\n  line-height: 1.5;\n}\n.fb__diagnostics-toggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 600;\n}\n.fb__diagnostics-toggle input[type=\"checkbox\"] {\n  width: auto;\n  flex: 0 0 auto;\n  margin: 0;\n  accent-color: var(--palette-primary);\n}\n.fb__diagnostics p {\n  margin: 10px 0;\n}\n.fb__diagnostics summary {\n  cursor: pointer;\n}\n.fb__diagnostics pre {\n  max-height: 240px;\n  overflow: auto;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n  font-size: 0.8rem;\n}\n\n.fb__sent {\n  padding-top: 8px;\n}\n.fb__sent-title {\n  font-family: var(--font-display);\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin-bottom: 10px;\n}\n.fb__sent-body {\n  color: var(--palette-text-muted);\n  line-height: 1.55;\n  margin: 0 0 18px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
